export const PropertyDetailSkeleton = () => (
  <section className="property-detail-page" aria-hidden="true">
    <div className="property-detail-container">
      <div className="property-detail-top skeleton-stack">
        <span className="skeleton title" />
      </div>

      <div className="property-detail-skeleton-gallery">
        <span className="skeleton property-detail-skeleton-hero" />
        <div className="property-detail-skeleton-grid">
          <span className="skeleton" />
          <span className="skeleton" />
          <span className="skeleton" />
          <span className="skeleton" />
        </div>
      </div>

      <div className="property-detail-body">
        <div className="property-detail-main skeleton-stack">
          <span className="skeleton text" />
          <span className="skeleton text short" />
          <span className="skeleton text" />
          <span className="skeleton text" />
        </div>
        <aside className="property-detail-sidebar">
          <div className="booking-widget skeleton-stack">
            <span className="skeleton title" />
            <span className="skeleton text" />
            <span className="skeleton text short" />
          </div>
        </aside>
      </div>
    </div>
  </section>
);
